import React from 'react';
import BasketDeliveryInfo from '../BasketDeliveryInfo/BasketDeliveryInfo';
import BasketHighlightedVouchers from '../BasketHighlightedVouchers/BasketHighlightedVouchers';
import BasketItems from '../BasketItems/BasketItems';
import { BasketRenderComponentProps } from '../BasketMain/BasketMain';
import OrderSummary from '../OrderSummary/OrderSummary';
import styles from './BasketMobile.module.scss';

const BasketMobile: React.FC<BasketRenderComponentProps> = ({
  onRemoveItem,
  onEditItem,
  onApplyVoucher,
  onRemoveVoucher,
  onChangeSelector,
  onCheckout,
}) => {
  return (
    <div>
      <div className={styles.cart}>
        <div className={styles.cartItems}>
          <BasketItems onRemoveItem={onRemoveItem} onEditItem={onEditItem} onChangeSelector={onChangeSelector} />
        </div>
        <div className={styles.deliveryInfo}>
          <BasketDeliveryInfo />
        </div>
        <div className={styles.orderSumnary}>
          <OrderSummary onApplyVoucher={onApplyVoucher} onRemoveVoucher={onRemoveVoucher} onCheckout={onCheckout} />
        </div>
      </div>
      <div className={styles.highlightedVouchers}>
        <BasketHighlightedVouchers />
      </div>
    </div>
  );
};

export default BasketMobile;
